/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkMegasearchResultDto } from '../models/work-megasearch-result-dto';
import { WorkSearchCategoryEnum } from '../models/work-search-category-enum';
import { WorkSearchIndexKeyEnum } from '../models/work-search-index-key-enum';
import { WorkSearchindexStatusDtoEvent } from '../models/work-searchindex-status-dto-event';
import { WorkSuccessDto } from '../models/work-success-dto';

@Injectable({ providedIn: 'root' })
export class WorkSearchV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `searchV2ControllerMegasearchBySearchterm()` */
  static readonly SearchV2ControllerMegasearchBySearchtermPath = '/v2/search/megasearch/{searchterm}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchV2ControllerMegasearchBySearchterm()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchV2ControllerMegasearchBySearchterm$Response(
    params: {
      searchterm: string;
      projectsSoldTrue?: boolean;
      searchCategories?: Array<WorkSearchCategoryEnum>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMegasearchResultDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSearchV2Service.SearchV2ControllerMegasearchBySearchtermPath, 'get');
    if (params) {
      rb.path('searchterm', params.searchterm, {});
      rb.query('projectsSoldTrue', params.projectsSoldTrue, {});
      rb.query('searchCategories', params.searchCategories, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMegasearchResultDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchV2ControllerMegasearchBySearchterm$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchV2ControllerMegasearchBySearchterm(
    params: {
      searchterm: string;
      projectsSoldTrue?: boolean;
      searchCategories?: Array<WorkSearchCategoryEnum>;
    },
    context?: HttpContext
  ): Observable<WorkMegasearchResultDto> {
    return this.searchV2ControllerMegasearchBySearchterm$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMegasearchResultDto>): WorkMegasearchResultDto => r.body)
    );
  }

  /** Path part for operation `searchV2ControllerMegasearchBySearchtermAndCategory()` */
  static readonly SearchV2ControllerMegasearchBySearchtermAndCategoryPath = '/v2/search/megasearch/{searchterm}/{searchCategory}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchV2ControllerMegasearchBySearchtermAndCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchV2ControllerMegasearchBySearchtermAndCategory$Response(
    params: {
      searchterm: string;
      searchCategory: WorkSearchCategoryEnum;
      projectsSoldTrue?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMegasearchResultDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSearchV2Service.SearchV2ControllerMegasearchBySearchtermAndCategoryPath, 'get');
    if (params) {
      rb.path('searchterm', params.searchterm, {});
      rb.path('searchCategory', params.searchCategory, {});
      rb.query('projectsSoldTrue', params.projectsSoldTrue, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMegasearchResultDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchV2ControllerMegasearchBySearchtermAndCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchV2ControllerMegasearchBySearchtermAndCategory(
    params: {
      searchterm: string;
      searchCategory: WorkSearchCategoryEnum;
      projectsSoldTrue?: boolean;
    },
    context?: HttpContext
  ): Observable<WorkMegasearchResultDto> {
    return this.searchV2ControllerMegasearchBySearchtermAndCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMegasearchResultDto>): WorkMegasearchResultDto => r.body)
    );
  }

  /** Path part for operation `searchV2ControllerRebuildIndexForSearchIndexKey()` */
  static readonly SearchV2ControllerRebuildIndexForSearchIndexKeyPath = '/v2/search/rebuildIndex/{searchIndexKey}';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchV2ControllerRebuildIndexForSearchIndexKey()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchV2ControllerRebuildIndexForSearchIndexKey$Response(
    params: {
      searchIndexKey: WorkSearchIndexKeyEnum;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSearchV2Service.SearchV2ControllerRebuildIndexForSearchIndexKeyPath, 'post');
    if (params) {
      rb.path('searchIndexKey', params.searchIndexKey, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchV2ControllerRebuildIndexForSearchIndexKey$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchV2ControllerRebuildIndexForSearchIndexKey(
    params: {
      searchIndexKey: WorkSearchIndexKeyEnum;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.searchV2ControllerRebuildIndexForSearchIndexKey$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `searchV2ControllerDeleteIndexForSearchIndexKey()` */
  static readonly SearchV2ControllerDeleteIndexForSearchIndexKeyPath = '/v2/search/deleteIndex/{searchIndexKey}';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchV2ControllerDeleteIndexForSearchIndexKey()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchV2ControllerDeleteIndexForSearchIndexKey$Response(
    params: {
      searchIndexKey: WorkSearchIndexKeyEnum;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSearchV2Service.SearchV2ControllerDeleteIndexForSearchIndexKeyPath, 'delete');
    if (params) {
      rb.path('searchIndexKey', params.searchIndexKey, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchV2ControllerDeleteIndexForSearchIndexKey$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchV2ControllerDeleteIndexForSearchIndexKey(
    params: {
      searchIndexKey: WorkSearchIndexKeyEnum;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.searchV2ControllerDeleteIndexForSearchIndexKey$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `searchV2ControllerListenToSearchindexStatus()` */
  static readonly SearchV2ControllerListenToSearchindexStatusPath = '/v2/search/searchindexStatus';

  /**
   * Required permissions: admin:all
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchV2ControllerListenToSearchindexStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchV2ControllerListenToSearchindexStatus$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSearchindexStatusDtoEvent>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSearchV2Service.SearchV2ControllerListenToSearchindexStatusPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/event-stream', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSearchindexStatusDtoEvent>;
      })
    );
  }

  /**
   * Required permissions: admin:all
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchV2ControllerListenToSearchindexStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchV2ControllerListenToSearchindexStatus(
    params?: {
    },
    context?: HttpContext
  ): Observable<WorkSearchindexStatusDtoEvent> {
    return this.searchV2ControllerListenToSearchindexStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSearchindexStatusDtoEvent>): WorkSearchindexStatusDtoEvent => r.body)
    );
  }

}
